import React from 'react';
// eslint-disable-next-line complexity
function matchesOrContainsValidationMessage(el) {
    const containsInvalid = el === null || el === void 0 ? void 0 : el.querySelector(':invalid');
    return (el === null || el === void 0 ? void 0 : el.validationMessage) || containsInvalid
        ? (containsInvalid === null || containsInvalid === void 0 ? void 0 : containsInvalid.validationMessage) || 'invalid input'
        : '';
}
// watchValue changes trigger updates
// elementRef will be queryied for invalid elements
export default function ValidationMessage({ watchValue, elementRef }) {
    const [validationMessage, setValidationMessage] = React.useState('');
    React.useEffect(() => setValidationMessage(matchesOrContainsValidationMessage(elementRef.current)), [watchValue, elementRef, setValidationMessage]);
    return React.createElement("div", { className: "invalid-message" }, validationMessage);
}
